import { useAppSelector } from '@shared/store';

/** Queries whose company comes from the JWT still need a tenant/user cache key. */
export const useWorkspaceScope = () =>
  useAppSelector((state) =>
    JSON.stringify([state.auth.authenticatedUser?.companyId, state.auth.authenticatedUser?.id]),
  );
